// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","header":"_3CDb"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Page/PageHeader/PageHeader.scss
// module id = Yn1M
// module chunks = 0